import Blog from "../components/Blog";
import SideBar from "../components/SideBar";

export default function Home() {
  return (
    <section className="wrapper">
      <SideBar />
      <Blog />
    </section>
  );
}
